import { render, staticRenderFns } from "./RoleSection.vue?vue&type=template&id=6fd84086&scoped=true&"
import script from "./RoleSection.vue?vue&type=script&lang=js&"
export * from "./RoleSection.vue?vue&type=script&lang=js&"
import style0 from "./RoleSection.vue?vue&type=style&index=0&id=6fd84086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd84086",
  null
  
)

export default component.exports